export default function reportSchedulesDirective() {
  return {
    template: require('./report-schedules.html'),
    controller: 'SRReportSchedulesController',
    controllerAs: 'srReportSchedulesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportType: '=',
    },
  };
}
